import { HalfImageHalfTextCardContainer } from '@bnnvara/cards/src/components/HalfImageHalfTextCard/HalfImageHalfTextCardContainer';
import { HalfImageHalfTextCardImage } from '@bnnvara/cards/src/components/HalfImageHalfTextCard/HalfImageHalfTextCardImage';
import { HalfImageHalfTextCardText } from '@bnnvara/cards/src/components/HalfImageHalfTextCard/HalfImageHalfTextCardText';
import { OnHoverTextEffect } from '@bnnvara/cards/src/components/shared/OnHoverTextEffect';
import { Small } from '@bnnvara/cards/src/components/shared/Small';
import { Title } from '@bnnvara/cards/src/components/shared/Title';
import { formatDate } from '@bnnvara/helpers';
import PropTypes from 'prop-types';
import React from 'react';
import { useTheme } from 'styled-components';

import resizeImageSource from '../../../helpers/resizeImageSource';
import { Bookmark } from '../../Bookmark/button/Bookmark';
import Link from '../../Link';
import * as S from './styled';

export const MixedContentCardWithBookmark = ({
  id,
  title,
  image,
  type,
  publishDate,
  linkVariables,
  commentCount,
}) => {
  const { href, category, action, label } = linkVariables;

  const thumbnail = resizeImageSource(
    image ? image.url || image : '/static/fallbackImages/videofallback.jpg',
    450,
    1
  );
  const pubDate = formatDate(new Date(publishDate));
  const theme = useTheme();
  const textAmountOfComments = commentCount === 1 ? 'reactie' : 'reacties';

  return (
    <HalfImageHalfTextCardContainer
      aria-label={`Jouw bewaarde artikel genaamd ${title}`}
    >
      <Link href={href} category={category} action={action} label={label}>
        <HalfImageHalfTextCardImage
          image={{
            alt: title,
            src: thumbnail,
          }}
        />
      </Link>
      <HalfImageHalfTextCardText>
        <Link href={href} category={category} action={action} label={label}>
          <OnHoverTextEffect>
            <Title color={theme.base.black}>{title}</Title>
          </OnHoverTextEffect>
        </Link>

        <S.Details>
          <Small color={theme.secondary.light}>{pubDate}&nbsp;</Small>
          {commentCount > 0 && (
            <Small color={theme.secondary.light}>
              · &nbsp;{`${commentCount} ${textAmountOfComments}`}
            </Small>
          )}
          <>
            <Small color={theme.secondary.light}> &nbsp;·&nbsp;</Small>
            <Bookmark
              size="s"
              textColor={theme.secondary.light}
              content={{
                id,
                title,
                type,
                publishDate,
                href,
                commentCount,
                image,
              }}
            />
          </>
        </S.Details>
      </HalfImageHalfTextCardText>
    </HalfImageHalfTextCardContainer>
  );
};

MixedContentCardWithBookmark.defaultProps = {
  image: null,
  commentCount: null,
};

MixedContentCardWithBookmark.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }),
  type: PropTypes.string.isRequired,
  publishDate: PropTypes.string.isRequired,

  linkVariables: PropTypes.shape({
    href: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    action: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,

  commentCount: PropTypes.number,
};

export default MixedContentCardWithBookmark;
